import { ReviewAndBookPageActions } from './actions';

const defaultState = {
    appointmentInfoIsValid: false,
    continueWasClicked: false,
    selectPatientIsValid: false,
    shouldShowLoadingAnimation: false,
};

export const reviewAndBookPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ReviewAndBookPageActions.VALIDATE_APPOINTMENT_INFO: {
            return {
                ...state,
                appointmentInfoIsValid: true,
            };
        }

        case ReviewAndBookPageActions.VALIDATE_SELECT_PATIENT: {
            return {
                ...state,
                selectPatientIsValid: true,
            };
        }

        case ReviewAndBookPageActions.CONTINUE_WAS_CLICKED: {
            return {
                ...state,
                continueWasClicked: true,
            };
        }

        case ReviewAndBookPageActions.HIDE_LOADING_ANIMATION: {
            return {
                ...state,
                shouldShowLoadingAnimation: false,
            };
        }

        case ReviewAndBookPageActions.SHOW_LOADING_ANIMATION: {
            return {
                ...state,
                shouldShowLoadingAnimation: true,
            };
        }

        case ReviewAndBookPageActions.SHOW_MISSING_FIELDS_ERROR: {
            return {
                ...state,
                showMissingFieldsError: true,
            };
        }
        case ReviewAndBookPageActions.SHOW_MENTAL_HEALTH_MISSING_ERROR: {
            return {
                ...state,
                showLifestanceMentalHealthMissingError: true,
            };
        }
        case ReviewAndBookPageActions.CLEAR_MENTAL_HEALTH_MISSING_ERROR: {
            return {
                ...state,
                showLifestanceMentalHealthMissingError: false,
            };
        }
        case ReviewAndBookPageActions.SET_MENTAL_HEALTH_QUESTIONNAIRE: {
            return {
                ...state,
                mentalHealthQuestionnaire: action.value,
            };
        }
        case ReviewAndBookPageActions.FETCH_SURVEY_SUCCEEDED: {
            return {
                ...state,
                surveyQuestionsData: action.payload,
            };
        }

        default:
            return state;
    }
};
